import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";

export const addDiscountToRentByValue = async (sessionKey, value) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/add/discount/custom`,
            method: "PUT",
            data: {
                value: Number(value),
            },
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
